import { TreeSelect } from "antd";
import { TreeSelectProps } from "antd/lib";
import type { BaseSelectRef } from "rc-select";
import { forwardRef } from "react";

import cn from "@/utils/tailwind/cn";

const FormTreeSelect = forwardRef<BaseSelectRef, TreeSelectProps>(
  ({ className, style, ...props }, ref) => (
    <TreeSelect
      showSearch
      className={cn(
        "[&_.ant-select-selection-placeholder]:!text-gray-400",
        className,
      )}
      dropdownStyle={{
        overflow: "auto",
        paddingTop: 4,
        paddingBottom: 4,
      }}
      ref={ref}
      style={{ width: "100%", height: "38px", ...style }}
      {...props}
    />
  ),
);
export default FormTreeSelect;
